<template>
  <div id="car">
    <!-- {{PlugJson}} -->
  </div>
</template>

<script>
export default {
  name: "car"
};
</script>

<style scoped>
</style>